import { ResponsiveMap } from '../types';

export function getBreakpointFromWidth(breakpoints: { [key: string]: number }, width: number): string {
  const sorted = Object.keys(breakpoints).sort((a, b) => breakpoints[a] - breakpoints[b]);
  const validBreakpoints = sorted.filter((x) => width > breakpoints[x]);
  // if we have a width with a smaller value than the first sorted value choose first.
  if (validBreakpoints.length == 0) return sorted[0];

  // otherwise choose the largest value that is < width
  return validBreakpoints[validBreakpoints.length - 1];
}

if (import.meta.vitest) {
  describe('getBreakpointFromWidth', () => {
    it('Chooses best fit breakpoint', () => {
      expect(getBreakpointFromWidth({ a: 200, b: 400, c: 800 }, 250)).toEqual('a');
      expect(getBreakpointFromWidth({ a: 200, b: 400, c: 800 }, 500)).toEqual('b');
      expect(getBreakpointFromWidth({ a: 200, b: 400, c: 800 }, 1500)).toEqual('c');
    });

    it('If smaller than smallest, return smallest', () => {
      expect(getBreakpointFromWidth({ a: 200, b: 400, c: 800 }, 100)).toEqual('a');
    });
  });
}

export function lookupBreakpoint<T>(breakpoint: string, value: T | ResponsiveMap<any, T>): T {
  // Presume reasonableness, since they have to supply each breakpoint in value
  // Thus we can assert that if value is ResponsiveMap<any, T> 'breakpoint' must exist in it.
  if ((typeof value == 'function' || typeof value == 'object') && value && breakpoint in value) {
    return (value as ResponsiveMap<any, T>)[breakpoint] as T;
  } else {
    return value as T;
  }
}

if (import.meta.vitest) {
  describe('lookupBreakpoint', () => {
    it('Lookup breakpoint in responsive map', () => {
      expect(lookupBreakpoint('a', { a: 1, b: 2, c: 3 })).toEqual(1);
      expect(lookupBreakpoint('b', { a: 1, b: 2, c: 3 })).toEqual(2);
    });
    it('Lookup breakpoint in singular object', () => {
      expect(lookupBreakpoint('a', 1)).toEqual(1);
    });
  });
}
